// libs
import React, {useEffect, useState} from 'react'
import { ToastContainer } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
// components 
// ... 
// config & functions 
// ...

function ImagePreview({imagepath, handleviewimagefn}) {

    const [Show, setShow] = useState(false);

    const hideModal = () => {
		setShow(false);
        handleviewimagefn(false); // make it 0 and remove component from parent div
	}

    useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }
        loadComponent();
    });

    return (
        <Modal show={Show}>
            <Modal.Header>
                <Modal.Title>Preview Image</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <img src={imagepath} className='img-fluid' />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" className="fs-14rem" onClick={hideModal}>Close</Button>
            </Modal.Footer>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
		</Modal>
    )
}
export default ImagePreview;
